import {Component, EventEmitter, Input, Output, OnInit, ViewChildren, QueryList, ViewChild} from '@angular/core';
import {ItemPedido} from "../objeto/ItemPedido";
import {ConstantsService} from "../services/ConstantsService";
import {CarrinhoService} from "../services/carrinho.service";
import {SiteCampoAdicionalComponent} from "../app/site-campo-adicional/site-campo-adicional.component";
import {AutorizacaoLojaService} from "../services/autorizacao-loja.service";
import {PixelTrackingService} from "../services/pixel-tracking.service";
import { AdicionaisCustomizadosComponent } from '../app/adicionais-customizados/adicionais-customizados.component';
import {MyDetectorDevice} from "../app/shared/MyDetectorDevice";
declare var $;
declare var fbq;
declare var gtag;

@Component({
  selector: 'app-site-adicionar-produto',
  templateUrl: './site-adicionar-produto.component.html',
  styleUrls: ['./site-adicionar-produto.component.scss']
})
export class SiteAdicionarProdutoComponent implements OnInit {
  @Input() itemPedido: ItemPedido;
  @Input() pedido: any;
  @Input() indiceItem: any;
  @Input() window: any;
  @Output() onInformarPeso = new EventEmitter();
  @Output() onErroEstoque = new EventEmitter<string>();

  ctrlAdicionais: QueryList<SiteCampoAdicionalComponent>;
  adicionaisCustomizados: AdicionaisCustomizadosComponent;

  produto: any = {};
  erro: any;
  estaRecebendoPedidos: boolean;
  mensagemAbrirPedidos: string;
  modoVisualizacao: boolean;
  modoVisualizacaoQRcode: boolean;
  permiteAgendamento: boolean;
  carregando = true;
  empresa: any;
  adicionandoProduto: any;
  isMobile = false;
  esgotouEstoque = false;

  constructor( private constantsService: ConstantsService, private carrinhoService: CarrinhoService,
               private autorizacaoLojaService: AutorizacaoLojaService,
               private pixelTrackingService: PixelTrackingService, private detectorDevice: MyDetectorDevice) {
    this.isMobile = this.detectorDevice.isMobile();
  }

  ngOnInit(): void {
    this.produto = this.itemPedido.produto;
    this.carregando = false;
    this.constantsService.empresa$.subscribe( (empresa) => {
      if (!empresa || !empresa.id) return;

      this.empresa = empresa;

      this.estaRecebendoPedidos = empresa.estaRecebendoPedidos;
      this.permiteAgendamento = empresa.permiteAgendamento;
      this.mensagemAbrirPedidos = empresa.mensagemAbrirPedidos;
      this.modoVisualizacao = empresa.cardapio && empresa.cardapio.modoVisualizacao;
      this.modoVisualizacaoQRcode = (empresa.cardapio && empresa.cardapio.modoVisualizacaoQRcode) ||
        (this.pedido && this.pedido.mesa &&  this.pedido.mesa.somenteLeitura);


    });
  }



  adicionarProduto() {
    delete this.erro;
    if( this.empresa.fechadoTemporariamente || (!this.estaRecebendoPedidos && !this.permiteAgendamento) ) {
      return  $("#alertaFechado").modal();
    }


    if( this.modoVisualizacaoQRcode && this.pedido.mesa ) {
      this.mensagemAbrirPedidos = 'Cardápio De Mesa apenas para visualização. Chame o garçom para fazer seu pedido!';
      return $("#alertaFechado").modal();
      return;
    }
    if( this.modoVisualizacao ) {
      this.mensagemAbrirPedidos = 'Faça seu pedido pelo nosso Whatsapp!';

      return $("#alertaFechado").modal();
    }

    if(this.adicionaisCustomizados){

      let validos = this.adicionaisCustomizados.valideCampos();

      if(!validos) {
        return;
      }

    }

    this.itemPedido.produto.empresa = {
      id: this.empresa.id,
      nome: this.empresa.nome,
      logo: this.empresa.logo,
      dominio: this.empresa.dominio
    };

    if(this.produto.camposAdicionais ) {
      let totalAdicionais = this.produto.camposAdicionais.length;

      for( let i = 0; i < totalAdicionais; i++ ) {
        const campoAdicional = this.produto.camposAdicionais[i];

        if(!this.itemPedido.valideCampoAdicional(campoAdicional)) {
          this.ctrlAdicionais.toArray()[i].exibaErro( campoAdicional.variacao ? 'Escolha uma opção' : 'Complemento é obrigatório');
          this.posicioneNoComplemento(campoAdicional);
          this.adicionandoProduto = false;
          return
        }
      }

      let posicaoSabor = this.produto.camposAdicionais.length - 1;

      for( let i = 0; i < this.itemPedido.sabores.length; i++ ) {
        const sabor = this.itemPedido.sabores[i];
        if(sabor.produto !== this.produto.id){
          for( let j = 0; j < sabor.camposAdicionais.length; j++ ) {
            posicaoSabor++
            const campoAdicionalSabor = sabor.camposAdicionais[j];

            if(!this.itemPedido.valideCampoAdicional(campoAdicionalSabor)) {

              this.ctrlAdicionais.toArray()[posicaoSabor].exibaErro('Complemento é obrigatório');
              this.posicioneNoComplemento(campoAdicionalSabor);
              this.adicionandoProduto = false;
              return
            }


          }
        }
      }
    }

    if(this.pedido.codigo)
      this.erro = String(`O pedido #${this.pedido.codigo} está aguardando pagamento`)

    let limiteProdutos =   this.empresa.cardapio ? this.empresa.cardapio.limiteProdutos : null;

    if(limiteProdutos){
      let qtdePedido = this.pedido.obtenhaQtdeItens(this.itemPedido) +  this.itemPedido.qtde;

      if(qtdePedido > limiteProdutos)
        this.erro = `Máximo de itens permitido no carrinho são ${limiteProdutos}`
    }

    if(!this.erro) {
      this.pixelTrackingService.trackAddToCart(this.itemPedido, this.pedido);

      if( typeof gtag !== 'undefined' ) {
        try {
          gtag('event', 'add_to_cart', {
            currency: 'BRL',
            value: this.itemPedido.total,
            items: [
              {
                id: this.itemPedido.produto.id,
                name: this.itemPedido.produto.nome,
                price: this.itemPedido.total / this.itemPedido.qtde,
                quantity: this.itemPedido.qtde
              }
            ]
          });
        } catch (error) {
          console.log(error);
        }
      }

      if (!this.indiceItem) {
         this.pedido.adicione(this.itemPedido.produto, this.itemPedido.qtde,
          this.itemPedido.observacao, this.itemPedido.adicionais, this.itemPedido.produtoTamanho, this.itemPedido.sabores);
      }
      else {
        this.pedido.edite(this.indiceItem, this.itemPedido.produto, this.itemPedido.qtde,
          this.itemPedido.observacao, this.itemPedido.adicionais, this.itemPedido.produtoTamanho, this.itemPedido.sabores);
      }

      this.adicionandoProduto = true
      this.carrinhoService.atualizeDescontosETaxas(this.pedido, this.empresa).then(() => {
        this.adicionandoProduto = false;
        this.window.close();
      });

    } else {
      this.adicionandoProduto = false;
    }
  }

  obtenhaErroEsgotado(){
    if(!this.produto.estoque.quantidade)
      return `Desculpe, não restam mais unidades no estoque.`;

    return `Desculpe, só restam ${this.produto.estoque.quantidade} unidades no estoque.`;
  }

  aumentarQtde() {
    const qtdeAtual = this.obtenhaQuantidadeAtual();
    const incremento = this.obtenhaIncremento();
    const novaQtde = Number((qtdeAtual + incremento).toFixed(3));

    if(this.obtenhaEstoqueDisponivel() != null && novaQtde > this.obtenhaEstoqueDisponivel()) {
      this.onErroEstoque.emit(this.obtenhaErroEsgotado());
      return;
    }

    if(this.esgotouEstoque){
      this.onErroEstoque.emit(this.obtenhaErroEsgotado());
      return;
    }

    this.itemPedido.qtde  = novaQtde;

    if( this.obtenhaPesoMaximo() != null && this.obtenhaQuantidadeAtual() > this.obtenhaPesoMaximo() ) {
      this.itemPedido.qtde = this.obtenhaPesoMaximo();
    }

    this.normalizarQuantidade();
    this.itemPedido.atualizeTotal()

    if(this.obtenhaEstoqueDisponivel() != null)
      this.esgotouEstoque = this.obtenhaEstoqueDisponivel() <= this.obtenhaQuantidadeAtual()
  }

  diminuirQtde() {
    const qtdeAtual = this.obtenhaQuantidadeAtual();
    this.itemPedido.qtde  =  Number((qtdeAtual  - this.obtenhaIncremento())
      .toFixed(3));

    if( this.obtenhaPesoMinimo() != null && this.obtenhaQuantidadeAtual() < this.obtenhaPesoMinimo() ) {
      this.itemPedido.qtde = (this.obtenhaPesoMinimo() || this.obtenhaQuantidadeMinima());
    }
    else if( this.obtenhaQuantidadeAtual() < this.obtenhaQuantidadeMinima() )
      this.itemPedido.qtde = this.obtenhaQuantidadeMinima();

    this.normalizarQuantidade();
    this.itemPedido.atualizeTotal()

    if(this.obtenhaEstoqueDisponivel() != null)
      this.esgotouEstoque = this.obtenhaEstoqueDisponivel() <= this.obtenhaQuantidadeAtual()

  }

  exibirUnidade() {
    return this.itemPedido.produto.tipoDeVenda &&
      this.itemPedido.produto.tipoDeVenda  === 'Peso';
  }

  podeAumentarQuantidade(): boolean {
    const qtdeAtual = this.obtenhaQuantidadeAtual();
    const incremento = this.obtenhaIncremento();
    const proximaQtde = Number((qtdeAtual + incremento).toFixed(3));
    const qtdMaxima = this.obtenhaQuantidadeMaxima();
    const estoqueDisponivel = this.obtenhaEstoqueDisponivel();
    const pesoMaximo = this.obtenhaPesoMaximo();

    if(qtdMaxima != null && proximaQtde > qtdMaxima) return false;
    if(pesoMaximo != null && proximaQtde > pesoMaximo) return false;
    if(estoqueDisponivel != null && proximaQtde > estoqueDisponivel) return false;

    return true;
  }

  podeDiminuirQuantidade(): boolean {
    const qtdeAtual = this.obtenhaQuantidadeAtual();
    const incremento = this.obtenhaIncremento();
    const proximaQtde = Number((qtdeAtual - incremento).toFixed(3));
    const minimo = this.exibirUnidade() ? this.obtenhaPesoMinimo() : this.obtenhaQuantidadeMinima();

    return proximaQtde >= minimo;
  }

  private normalizarQuantidade() {
    const qtdeAtual = Number(this.itemPedido.qtde);
    if(!Number.isFinite(qtdeAtual) || qtdeAtual <= 0) {
      if(this.exibirUnidade()) {
        this.itemPedido.qtde = this.obtenhaPesoMinimo();
      } else {
        this.itemPedido.qtde = this.obtenhaQuantidadeMinima();
      }
      return;
    }

    this.itemPedido.qtde = qtdeAtual;
  }

  private obtenhaQuantidadeAtual(): number {
    const qtdeAtual = Number(this.itemPedido?.qtde);
    return Number.isFinite(qtdeAtual) && qtdeAtual > 0 ? qtdeAtual : this.obtenhaQuantidadeMinima();
  }

  private obtenhaIncremento(): number {
    const incremento = Number(this.itemPedido?.produto?.incremento || 1);
    return Number.isFinite(incremento) && incremento > 0 ? incremento : 1;
  }

  private obtenhaQuantidadeMinima(): number {
    const minimo = Number(this.produto?.qtdeMinima ?? this.itemPedido?.produto?.valorInicial ?? 1);
    return Number.isFinite(minimo) && minimo > 0 ? minimo : 1;
  }

  private obtenhaQuantidadeMaxima(): number | null {
    if(this.produto?.qtdMaxima == null || this.produto?.qtdMaxima === '')
      return null;

    const maximo = Number(this.produto.qtdMaxima);
    return Number.isFinite(maximo) && maximo > 0 ? maximo : null;
  }

  private obtenhaPesoMinimo(): number {
    const minimo = Number(this.produto?.pesoMinimo ?? this.itemPedido?.produto?.valorInicial ?? 1);
    return Number.isFinite(minimo) && minimo > 0 ? minimo : 1;
  }

  private obtenhaPesoMaximo(): number | null {
    if(this.produto?.pesoMaximo == null || this.produto?.pesoMaximo === '')
      return null;

    const maximo = Number(this.produto.pesoMaximo);
    return Number.isFinite(maximo) && maximo > 0 ? maximo : null;
  }

  private obtenhaEstoqueDisponivel(): number | null {
    if(this.produto?.estoque?.quantidade == null || this.produto?.estoque?.quantidade === '')
      return null;

    const estoque = Number(this.produto.estoque.quantidade);
    return Number.isFinite(estoque) && estoque >= 0 ? estoque : null;
  }

  posicioneNoComplemento(campoAdicional) {
    const $controleAdicional = document.getElementById('adicional_' + campoAdicional.id);

    if($controleAdicional ) {
      const topo = $controleAdicional.offsetTop - 10;

      document.querySelector('.k-dialog-content').scrollTo(0, topo);
    } else {
      setTimeout(() => {
        let $erros: any = document.getElementsByClassName('alert-danger');

        if(!$erros || !$erros.length)
          $erros = document.getElementsByClassName('badge-danger');

        if($erros && $erros.length){
          const topo =   $erros[0].offsetTop - 40;
          document.querySelector('.k-dialog-content').scrollTo(0, topo)
        }

      }, 0)

    }

  }

  informarPeso() {
    this.onInformarPeso.emit({})
  }

  setControlesAdicionais(ctrlAdicionais: QueryList<SiteCampoAdicionalComponent>, adicionaisCustomizados: AdicionaisCustomizadosComponent) {
    this.ctrlAdicionais = ctrlAdicionais;
    this.adicionaisCustomizados = adicionaisCustomizados;
  }
}
